import GroupedDetails from './GroupedDetails';

export default GroupedDetails;
